/* Imports */
import React from 'react'

/* Functional Component */
function Heading(props) {
  return (
    <span className='font-semibold text-darkPurple mr-4 text-sm'>{props.text}</span>
  )
}

/* Exports */
export default Heading